export enum SrcType {
    Legacy = "Legacy",
    CincSocial = "CINC-Social"
}
